import { useDatabases } from "./useDatabases";
import { useCurrentInventoryId, useCurrentProjectId } from "../url";
import { useListProjects } from "./usePouchList";
import { usePouchGet } from "./usePouchGet";

export function useCurrentProject() {
  const { projects } = useDatabases();
  const { projectId } = useCurrentProjectId();

  // if in an inventory the URL will not contain the projectId, so we need to look it up
  const { inventoryId } = useCurrentInventoryId();
  const projectsList = useListProjects({ enabled: projectId === undefined });
  const foundProject =
    inventoryId === undefined ? undefined : projectsList.data?.find((p) => p.inventories && inventoryId in p.inventories);

  return usePouchGet(["projects"], projects, projectId || foundProject?._id);
}
